<template>
	<div class="signing-content review confirm-box in-modal fade-down">
        <div class="pdf-viewer-top signing-top">
            <div class="top">
                <div class="logo"></div>
                <div class="content">
                    <h1>{{$t('preview.contract.headline') }}</h1>
                    <p>{{getSingleProperty.address}}</p>
                </div>
                <div class="button-container">
                    <button class="button transparent" id="download-pdf-link" v-on:click="downloadModal()">{{$t('button.download.label')}}</button>
                    <button class="purple" v-on:click="close()">{{ $t('digital.pdf-viewer.close') }}</button>
                </div>
            </div>
        </div>
        <div class="pdf-viewer">
            <PdfViewer :url="url" />
        </div>

        <!-- Modal -->

        <download-contract-modal v-if="showDownloadModal" v-on:close="showDownloadModal = false" :url="pdfUrl"></download-contract-modal>

    </div>
</template>

<script>
	import { mapGetters } from 'vuex';
    import PdfViewer from './PdfViewer.vue';
    import SvgIcon from './Svg';
    import DownloadContractModal from "./DownloadContractModal";

	export default {
		props: [
			'url'
		],
        components: {
            DownloadContractModal,
            PdfViewer,
            SvgIcon
        },
        data: () => ({
            loading: true,
            urlStore: '',
            useUrl: '',
            showDownloadModal: false,
            termsAccepted: false
        }),
		computed: {
			...mapGetters([
				'getSingleProperty'
			]),
            pdfUrl() {
                return this.useUrl ? this.useUrl : this.url;
            }
		},
        watch: {
            url() {
                this.loading = true;
            }
        },
		methods: {
			close() {
				this.$root.$emit('close-contract-preview');
				this.$emit('close');
			},
            downloadModal: function() {
                this.showDownloadModal = !this.showDownloadModal;
            },
		}
	}
</script>

<style>
    #download-pdf-link {
        margin-right: 15px;
    }
</style>
